import styled from 'styled-components';
import Typography from '~components/dumbs/Typography';

export const Subtitle = styled(Typography).attrs({ as: 'h3' })`
  margin-bottom: ${({ theme }) => theme.spacing.km5};
`;
